module.exports = "/_next/static/images/ticket-search-ddf9f6c641ee7c066c872660e1ef9600.png";